// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccountOverviewStyles } from "@rpsc/App/Widgets/AccountOverview/AccountOverview";
import { color, linkArrowStyle, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

AccountOverviewStyles.tileList = {
    css: css`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 22px;

        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

AccountOverviewStyles.tile = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 18px;
        padding: 14px 12px 12px;
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        button {
            width: fit-content;
        }
    `,
};

AccountOverviewStyles.image = {
    css: css`
        min-width: 34px;
        max-height: 34px;
        padding: 0;
        & img {
            display: flex;
            width: 34px;
            height: 34px;
            padding: 0;
        }
    `,
};

AccountOverviewStyles.titleWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        flex: 1;
    `,
};

AccountOverviewStyles.title = {
    css: css`
        margin: 0;
    `
}

AccountOverviewStyles.link = {
    ...mergeWithCss(linkArrowStyle, {
        typographyProps: {
            size: 16,
            css: css`
                line-height: 22px;
            `
        },
        css: css`
            align-self: start;
        `,
    }),
};
